import { Loader2 } from "lucide-react";

export default function FeuButton({
  level,
  title,
  subtitle,
  icon: Icon,
  disabled = false,
  comingSoon = false,
  loading = false,
  onClick,
  testId,
}) {
  const palette = {
    green: { bg: "#22C55E", hover: "#16A34A", shadow: "rgba(34,197,94,0.35)" },
    orange: { bg: "#F59E0B", hover: "#D97706", shadow: "rgba(245,158,11,0.35)" },
    red: { bg: "#EF4444", hover: "#DC2626", shadow: "rgba(239,68,68,0.35)" },
  }[level];

  return (
    <button
      type="button"
      disabled={disabled || loading}
      onClick={onClick}
      data-testid={testId}
      className="group relative w-full overflow-hidden rounded-[20px] text-left transition-transform active:translate-y-[1px] disabled:cursor-not-allowed disabled:opacity-75"
      style={{
        minHeight: 88,
        background: palette.bg,
        boxShadow: `0 8px 24px -8px ${palette.shadow}`,
      }}
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-0 transition-opacity group-enabled:group-hover:opacity-100"
        style={{ background: palette.hover }}
      />
      <div className="relative flex items-center gap-4 px-5 py-5 text-white">
        <div
          className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[16px]"
          style={{ background: "rgba(255,255,255,0.18)" }}
        >
          {loading ? <Loader2 size={26} className="animate-spin" /> : <Icon size={28} strokeWidth={2.2} />}
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-center gap-2">
            <span
              className="text-[17px] font-bold"
              style={{ letterSpacing: "-0.015em" }}
            >
              {title}
            </span>
            {comingSoon ? (
              <span className="rounded-full bg-white/25 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider">
                Bientôt
              </span>
            ) : null}
          </div>
          <span className="mt-0.5 text-[12.5px] font-medium text-white/90 leading-snug">
            {subtitle}
          </span>
        </div>
      </div>
    </button>
  );
}
